


import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaPlus, FaEdit } from "react-icons/fa";
import CreateTeacherModal from "./CreateTeacherModal";
import Swal from "sweetalert2";
import { RiDeleteBin5Line } from "react-icons/ri";



const Teacher = () => {
  const [showTeacherModal, setShowTeacherModal] = useState(false);
  const [teachers, setTeachers] = useState([]);
  const [selectedTeacher, setSelectedTeacher] = useState(null);
    const [classes, setClasses] = useState([]);

  const [userId] = useState(1);
  
  

  const fetchTeachers = async () => {
    try {
      const response = await axios.get("https://api.scannscore.com/teacher");
      //  console.log("Logged userId:", userId);

      const filteredTeachers = response.data.filter(
        (teacher) => teacher.id !== 1
            
      );
      
    
      if (userId === 1) {
        setTeachers(filteredTeachers);
        
      } else {
        setTeachers([]);
      }
    } catch (error) {
      console.error("Error fetching teachers:", error);
    }
  };


  const fetchClasses = async () => {
    try {
      const res = await axios.get("https://api.scannscore.com/class");
      if (res.status === 200) {
        setClasses(res.data);
      }
    } catch (err) {
      console.error("Error fetching classes:", err);
      
    }
  };

  const fetchData = async () => {
  try {
 
    const teacherRes = await axios.get("https://api.scannscore.com/teacher");
    const allTeachers = teacherRes.data.filter(t => t.id !== 1);

    const classRes = await axios.get("https://api.scannscore.com/class");
    const allClasses = classRes.data; 

 
    const assignedTeacherIds = new Set(allClasses.map(c => c.user_id));

    const teachersWithStatus = allTeachers.map(t => ({
      ...t,
      hasClass: assignedTeacherIds.has(t.id), 
    }));


    if (userId === 1) {
      setTeachers(teachersWithStatus);
    } else {
      setTeachers([]); 
    }

  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

  useEffect(() => {
    fetchTeachers();
    fetchClasses();
    fetchData();
  }, [userId]);

  const cardStyle = {
    background: "#fff",
    padding: "15px 20px",
    borderRadius: "10px",
    boxShadow: "0 4px 6px rgb(0 0 0 / 0.1)",
    borderLeft: "5px solid #2649cf",
    height: "100%",
    position: "relative",
    overflow: "hidden",       
    wordWrap: "break-word",    
  };


  
  const handleDelete = async (teacherId) => {
  const result = await Swal.fire({
    title: "Delete Exam?",
    text: "This will permanently delete the teacher . This action cannot be undone.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#6c757d",
    confirmButtonText: "Yes, delete it",
    cancelButtonText: "Cancel",
  });

  if (result.isConfirmed) {
    try {
      await axios.delete(`https://api.scannscore.com/delete-teacher/${teacherId}`);

      Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: "The exam has been successfully deleted.",
        timer: 1500,
        showConfirmButton: false,
      });

 fetchTeachers();
    } catch (error) {
      console.log(error)
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to delete the exam. Please try again.",
      });
    }
  }
};


  return (
    <div
      className="p-3 p-md-4"
      style={{
        minHeight: "100vh",
        background: "#f4f6ff",
      }}
    >
 
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="fw-bold">Teacher</h2>

        {userId === 1 && (
          <button
            className="btn btn-primary d-flex align-items-center"
            onClick={() => {
              setSelectedTeacher(null);
              setShowTeacherModal(true);
            }}
          >
            <FaPlus className="me-2" />
            New Teacher
          </button>
        )}
      </div>


      {/* <div className="row g-3">
        {teachers.length === 0 ? (
          <p className="text-center text-muted mt-5">
            No teachers found
          </p>
        ) : (
          teachers.map((teacher) => (
            <div
              key={teacher.id}
              className="col-12 col-sm-6 col-md-4 col-lg-3"
            >
              <div style={cardStyle}>
                
                {userId === 1 && (
                  <button
                    style={editBtn}
                    onClick={() => {
                      setSelectedTeacher(teacher);
                      setShowTeacherModal(true);
                    }}
                  >
                    <FaEdit />
                  </button>
                )}  
                
                 
           
                <h5
                  className="fw-bold"
                  style={{ wordBreak: "break-word" }}
                >
                  {teacher.name}
                </h5>

                <p
                  className="text-muted small mb-0"
                  style={{ wordBreak: "break-all" }}
                >
                  {teacher.email}
                </p>


                  {teacher.hasClass ? (
            <span className="badge bg-success mt-2">Assigned</span>
          ) : (
            <span className="badge bg-secondary mt-2">Not Assigned</span>
          )}
              </div>
            </div>
          ))
        )}
      </div> */}



<div className="row g-3">
  {teachers.length === 0 ? (
    <p className="text-center text-muted mt-5">No teachers found</p>
  ) : (
    teachers.map((teacher) => (
      <div key={teacher.id} className="col-12 col-sm-6 col-md-4 col-lg-4">
        <div 
        className=" d-flex justify-content-between"
          style={{
            ...cardStyle,
            // position: "relative", 
            paddingBottom: "20px", 
          }}
        >

          
          <div>
          <h5 className="fw-bold" style={{ wordBreak: "break-word", marginTop: "8px" }}>
            {teacher.name}
          </h5>
          <p className="text-muted small mb-0" style={{ wordBreak: "break-all", textWrap: "wrap" }}>
            {teacher.email}
          </p>
          </div>

          {/* Edit button on top-left */}
          <div>
          {userId === 1 && (
            <button
              className="btn btn-primary px-2"
              onClick={() => {
                setSelectedTeacher(teacher);
                setShowTeacherModal(true);
              }}
            >
              <FaEdit />
            </button>
            
          )}

                    {/* Delete button at bottom-right */}
          {userId === 1 && !teacher.hasClass && (
            <>
            <br />
            <button
              className="btn btn-danger px-2 mt-2"
              onClick={() => handleDelete(teacher.id)}
              // style={{
              //   position: "absolute",
              //   bottom: "10px",
              //   right: "10px",
              // }}
            ><RiDeleteBin5Line />
            </button>
</>          )}  
          </div>

          {/* Teacher info */}


        


        </div>
      </div>
    ))
  )}
</div>
     
      {userId === 1 && (
        <CreateTeacherModal
          show={showTeacherModal}
          closeModal={() => {
            setShowTeacherModal(false);
            fetchTeachers();
          }}
          teacherData={selectedTeacher}
        />
      )}
    </div>
  );
};

export default Teacher;

const editBtn = {
  position: "absolute",
  top: "10px",
  right: "10px",
  border: "none",
  background: "#2649cf",
  color: "#fff",
  padding: "6px 8px",
  borderRadius: "5px",
  cursor: "pointer",
};